import { useSite } from "../context/SiteContext";

export default function Rates() {
  const { content } = useSite();
  const rates = content.rates || [];
  const included = content.included || [];
  const extras = content.extras || [];
  const notOffered = content.not_offered || [];
  const deposit = content.deposit || [];

  return (
    <section id="rates" className="section relative" data-testid="rates-section">
      <div className="container-x px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="eyebrow justify-center mx-auto mb-4">Rates & Services</div>
          <h2 className="font-display text-4xl md:text-6xl text-gold leading-tight">
            All the details,{" "}
            <span className="italic text-ivory">none of the surprises.</span>
          </h2>
          <p className="text-ivory-dim mt-4">
            AUD. Incalls in Liverpool. Outcalls: Sydney metro (+$50 travel
            within 20km, POA beyond).
          </p>
        </div>

        <div className="card-luxe overflow-hidden" data-testid="rates-table">
          <div className="grid grid-cols-[1.4fr_1fr_1fr] px-5 py-3 text-[0.7rem] uppercase tracking-[0.22em] text-[color:var(--muted)] border-b border-[rgba(201,169,97,0.2)]">
            <span>Duration</span>
            <span>Incall</span>
            <span>Outcall</span>
          </div>
          {rates.map((r) => (
            <div
              key={r.duration}
              className={`rate-row ${r.featured ? "featured" : ""}`}
              data-testid={`rate-row-${r.duration.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <span className="font-serif text-lg text-ivory">
                {r.duration}
                {r.featured && (
                  <span className="ml-2 text-[0.65rem] uppercase tracking-widest text-gold">
                    · popular
                  </span>
                )}
              </span>
              <span className="font-serif text-lg text-gold">{r.incall}</span>
              <span className="font-serif text-lg text-gold-2">{r.outcall}</span>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-6 mt-8">
          <div className="card-luxe p-6 md:p-8" data-testid="included-card">
            <div className="eyebrow mb-4">Included · every booking</div>
            <h3 className="font-display text-3xl text-ivory mb-5">
              No extra charge.
            </h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 text-ivory-dim text-sm md:text-[0.95rem]">
              {included.map((it) => (
                <li key={it} className="flex gap-2 leading-snug">
                  <span className="text-gold mt-1 flex-shrink-0">✦</span>
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="card-luxe p-6 md:p-8" data-testid="extras-card">
            <div className="eyebrow mb-4">Extras · add to any booking</div>
            <h3 className="font-display text-3xl text-ivory mb-5">Turn it up.</h3>
            <ul className="divide-y divide-[rgba(201,169,97,0.14)]">
              {extras.map((e) => (
                <li
                  key={e.name}
                  className="flex justify-between items-baseline gap-4 py-2.5"
                >
                  <span className="text-ivory-dim text-sm md:text-[0.95rem] leading-snug">
                    {e.name}
                  </span>
                  <span className="font-serif text-lg text-gold whitespace-nowrap">
                    {e.price}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 mt-6">
          <div
            className="p-6 md:p-8 rounded-2xl border border-[rgba(122,30,43,0.45)] bg-[rgba(122,30,43,0.08)]"
            data-testid="not-offered-card"
          >
            <div className="eyebrow mb-4" style={{ color: "#e57786" }}>
              Firm boundaries
            </div>
            <h3 className="font-display text-3xl text-ivory mb-5">Not offered.</h3>
            <ul className="space-y-3 text-ivory-dim">
              {notOffered.map((n, i) => (
                <li key={i} className="flex gap-3 leading-relaxed">
                  <span className="text-[#e57786] mt-1 flex-shrink-0">✕</span>
                  <span>{n}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="card-luxe p-6 md:p-8" data-testid="deposit-card">
            <div className="eyebrow mb-4">Deposit policy</div>
            <h3 className="font-display text-3xl text-ivory mb-5">Keep it clean.</h3>
            <ul className="space-y-3 text-ivory-dim">
              {deposit.map((n, i) => (
                <li key={i} className="flex gap-3 leading-relaxed">
                  <span className="text-gold mt-1 flex-shrink-0">◆</span>
                  <span>{n}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
